import { handleActions } from 'redux-actions';

import * as actionCreators from '../actionCreators/readers';

const defaultState = {
  updateDevices: []
};

const readersReducer = handleActions(
  {
    [actionCreators.doReadDeviceUpdateList]: (state, { payload: { updateDevices = [] } }) => {
      return {
        ...state,
        updateDevices: updateDevices,
      };
    },
  },
  defaultState,
);

export default readersReducer;
